module.exports = require("./nl-BE.d.ts");